/**
* Index.ts
* @author Abhilash Panwar (abpanwar)
* @copyright Microsoft 2018
* File to export public classes, interfaces and enums.
*/
import "@microsoft/applicationinsights-shims";
import {
    ValueKind, IPropertyStorageOverride, IPlugin,
    EventLatency, EventPersistence, TraceLevel, IEventProperty, IExtendedTelemetryItem,
    IChannelControls, ITelemetryPlugin, MinChannelPriorty, INotificationListener,
    NotificationManager, EventsDiscardedReason, CoreUtils, IDiagnosticLogger, DiagnosticLogger,
    isValueAssigned, isArray, isBeaconsSupported, isBoolean, isLatency, isNumber, isReactNative,
    isString, isUint8ArrayAvailable, getISOString, cookieAvailable,
} from "@ms/1ds-core-js";
import { PropertiesPlugin, IPropertyConfiguration } from "@ms/1ds-properties-js";
import {
    PostChannel, IChannelConfiguration, IPayloadData, PayloadPreprocessorFunction,
    BE_PROFILE, NRT_PROFILE, RT_PROFILE, IXHROverride,
} from "@ms/1ds-post-js";
import { IExtendedConfiguration } from "./DataModels";
import ApplicationInsights from "./ApplicationInsights";

export {
    MinChannelPriorty, ValueKind, IExtendedConfiguration, IPropertyStorageOverride, IPlugin,
    EventLatency, EventPersistence, TraceLevel, IEventProperty, IExtendedTelemetryItem,
    IChannelControls, ITelemetryPlugin, ApplicationInsights, INotificationListener, NotificationManager,
    PropertiesPlugin, IPropertyConfiguration, PostChannel, IChannelConfiguration, CoreUtils,
    BE_PROFILE, NRT_PROFILE, RT_PROFILE, IXHROverride, EventsDiscardedReason, IPayloadData, PayloadPreprocessorFunction,
    IDiagnosticLogger, DiagnosticLogger,
    isValueAssigned, isArray, isBeaconsSupported, isBoolean, isLatency, isNumber, isReactNative,
    isString, isUint8ArrayAvailable, getISOString, cookieAvailable,
};
